import { CardCvcElement } from '@stripe/react-stripe-js';
import type { StripeCardCvcElementChangeEvent } from '@stripe/stripe-js';
import { Box, FieldLabel, Stack } from 'braid-design-system';
import type React from 'react';

import type { CreditCardFormValidationErrors } from '../../../../usecases/CreditCard/creditcardTypes';

import ValidationMesasge from './ValidationMessage';

import * as styles from './Elements.css';

interface Props {
  label: string;
  onInputChange: (event: StripeCardCvcElementChangeEvent, id: string) => void;
  formValidationErrors: CreditCardFormValidationErrors;
}

const CardCVCInput: React.FC<Props> = ({
  label,
  onInputChange,
  formValidationErrors,
}) => {
  const id = 'card-cvc';

  return (
    <Stack space="xsmall">
      <FieldLabel label={label} htmlFor={`input-${id}`} />
      <Box className={styles.inputBox}>
        <CardCvcElement
          id={`input-${id}`}
          onChange={(e) => onInputChange(e, id)}
          options={{
            placeholder: '123',
          }}
        />
      </Box>
      <ValidationMesasge errors={formValidationErrors} field={id} />
    </Stack>
  );
};

export { CardCVCInput };
